/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placedetailgallery2Inputs */

const en_placedetailgallery2 = /** @type {(inputs: Placedetailgallery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

const de_placedetailgallery2 = /** @type {(inputs: Placedetailgallery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Placedetailgallery2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placedetailgallery2 = /** @type {((inputs?: Placedetailgallery2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placedetailgallery2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placedetailgallery2(inputs)
	return de_placedetailgallery2(inputs)
});
export { placedetailgallery2 as "placeDetailGallery" }